import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
interface IProps {
  text: any;
  clicked: (value: any) => void;
  className?: any;
  btnType?: any;
  disabled?: any;
  forGrid?: boolean;
  withoutBack?: boolean;
}
const GeneralButton: React.FC<IProps> = ({
  text,
  clicked,
  className,
  btnType,
  disabled,
  forGrid,
  withoutBack,
}) => {
  const Styles = makeStyles((theme: Theme) =>
    createStyles({
      btn: {
        minWidth: "100%",
        maxWidth: "100%",
        height: "40px",
        borderRadius: "8px",
        border: "none",
        maxHeight: "40px",
        boxShadow: "none",
        background: "transparent",
        backgroundColor: withoutBack ? "transparent" : "transparent !important",
        "&:hover": {
          boxShadow:
            !!forGrid && forGrid
              ? "none"
              : "rgb(0 0 0 / 18%) 0px 1px 8px !important",
          "& .MuiButton-label": {
            color: "#000000b3",
          },
          border: "none",
          background:
            !!forGrid && forGrid ? "center" : theme.customColors.button,
        },
        fontSize: !!forGrid && forGrid ? "14px" : "16px",
        "& .MuiButton-label": {
          color: "#000000b3",
        },
        "& .MuiButton-contained.Mui-disabled": {
          backgroundColor: "transparent !important",
        },
      },
      blueBtn: {
        minWidth: "100%",
        borderRadius: "8px",
        height: "40px",
        maxHeight: "40px",
        boxShadow: "none !important",
        background: theme.customColors.dark + " !important",
        backgroundColor: theme.customColors.dark + " !important",
        "& .MuiButton-label": {
          color: theme.customColors.childBack,
        },
        "&:hover": {
          background: !!forGrid && forGrid ? "center" : "transparent",
          boxShadow: "rgb(0 0 0 / 18%) 0px 1px 8px !important",
        },
        fontSize: !!forGrid && forGrid ? "14px" : "16px",
        "& .MuiButton-contained.Mui-disabled": {
          backgroundColor: theme.customColors.dark + " !important",
        },
      },
      blackBtn: {
        minWidth: "100%",
        borderRadius: "8px",
        background: theme.customColors.title + " !important",
        backgroundColor: theme.customColors.title + " !important",
        "& .MuiButton-label": {
          fontWeight: 700,
          color: theme.customColors.childBack,
        },
      },
      secondary: {
        minWidth: "100%",
        borderRadius: "8px",
        height: "40px",
        maxHeight: "40px",
        boxShadow: "none",
        // backgroundColor: "white",
        background: "transparent",
        backgroundColor: "transparent !important",
        border: "none",
        "&:hover": {
          boxShadow: "rgb(0 0 0 / 18%) 0px 1px 8px !important",
          border: "none",
          background:
            !!forGrid && forGrid ? "center" : theme.customColors.secondary,
        },
        fontSize: !!forGrid && forGrid ? "14px" : "16px",
        "& .MuiButton-label": {
          color: "#000000b3",
        },
        "& .MuiButton-contained.Mui-disabled": {
          backgroundColor: "transparent !important",
        },
      },
      OrngBtn: {
        minWidth: "100%",
        borderRadius: "8px",
        height: "40px",
        maxHeight: "40px",
        boxShadow: "none !important",
        background: theme.customColors.dark + " !important",
        backgroundColor: "#FF4F01" + " !important",
        "& .MuiButton-label": {
          color: theme.customColors.childBack,
        },
        "&:hover": {
          background: !!forGrid && forGrid ? "center" : "transparent",
          boxShadow: "rgb(0 0 0 / 18%) 0px 1px 8px !important",
        },
        fontSize: !!forGrid && forGrid ? "14px" : "16px",
        "& .MuiButton-contained.Mui-disabled": {
          backgroundColor: theme.customColors.dark + " !important",
        },
      },
      whiteBtn: {
        minWidth: "100%",
        borderRadius: "8px",
        height: "40px",
        maxHeight: "40px",
        boxShadow: "none !important",
        border: "1px solid " + theme.customColors.title,
        // backgroundColor: "white",
        background: "transparent",
        backgroundColor: "transparent !important",
        "&:hover": {
          background: !!forGrid && forGrid ? "center" : "transparent",
          boxShadow: "rgb(0 0 0 / 18%) 0px 1px 8px !important",
        },
        fontSize: !!forGrid && forGrid ? "14px" : "16px",
        "& .MuiButton-label": {
          color:
            !!forGrid && forGrid
              ? theme.customColors.secondary
              : theme.customColors.title,
        },
        "& .MuiButton-contained.Mui-disabled": {
          backgroundColor: "transparent !important",
        },
      },
      disabledBtn: {
        opacity: "0.6",
      },
      "@media (max-width: 768px)": {
        blueBtn: {
          fontSize: "11px",
          width: "100px",
        },
        whiteBtn: {
          fontSize: "11px",
          width: "100px",
        },
      },
    })
  );
  const classes = Styles();
  const [disableButton, setDisableButton] = useState(disabled);
  useEffect(() => {
    setDisableButton(!!disabled ? disabled : false);
  }, [disabled]);
  useEffect(() => {}, [disableButton]);
  const submit = (value: any) => {
    if (!!forGrid && forGrid) {
      clicked(value);
    } else {
      setDisableButton(true);
      clicked(value);
      setTimeout(() => {
        setDisableButton(disabled);
      }, 3000);
    }
  };

  let classNames = classes.btn;
  if (btnType === "Secondary") {
    classNames = classes.secondary;
  } else if (btnType === "WhiteBtn") {
    classNames = classes.whiteBtn;
  } else if (btnType === "BlueBtn") {
    classNames = classes.blueBtn;
  } else if (btnType === "BlackBtn") {
    classNames = classes.blackBtn;
  } else if (btnType === "OrangeBtn") {
    classNames = classes.OrngBtn;
  }

  return (
    <Button
      onDoubleClick={() => {
        return null;
      }}
      disabled={disableButton}
      color="primary"
      variant="contained"
      className={[
        !!disableButton ? classes.disabledBtn : "",
        className,
        classNames,
      ].join(" ")}
      onClick={submit}
    >
      {text}
    </Button>
  );
};

export default GeneralButton;
